module.exports = __webpack_public_path__ + "img/KTB.c4706abf.png";